// import React, { useState } from "react";
// import "../CSS/faq.css"; // Move your CSS here
// import Sidebar from "./Sidebar";

// const faqData = [
//   {
//     question: "How do I contribute in a film project?",
//     answer:
//       "To contribute in a film project on Cinevestor, simply browse our available projects, select one that interests you, and click the 'Contribute Now' button. You'll need to complete our contributor onboarding process, which includes verifying your identity and agreeing to the contribution terms. Minimum contributions vary by project.",
//     category: "Contributing",
//   },
//   {
//     question: "What is the typical return on contribution?",
//     answer:
//       "Potential Profits varies by project and depends on many factors including the project's budget, distribution deals, and overall success. Our historical average Potential Profits ranges from 15-30%, but this is not guaranteed. Each project page shows projected Potential Profits based on financial models.",
//     category: "Projects",
//   },
//   {
//     question: "How are profits distributed?",
//     answer:
//       "Profits are distributed quarterly after the project's release. Payments are made directly to your registered bank account once the project has recouped its production costs. You'll receive detailed financial reports showing revenue streams from theatrical, streaming, TV, and other distribution channels.",
//     category: "Payments",
//   },
//   {
//     question: "What happens if a project doesn't get funded?",
//     answer:
//       "If a project doesn't reach its funding goal by the deadline, all committed funds are returned to contributors in full. You won't be charged anything, and we'll notify you immediately if a project you're interested in doesn't get funded.",
//     category: "Projects",
//   },
//   {
//     question: "Can I sell my contribution to someone else?",
//     answer:
//       "Currently, contributions in film projects are illiquid and cannot be sold on a secondary market. However, we're developing a marketplace for future trading of film contributions. You'll maintain your contribution position until the project completes its revenue cycle.",
//     category: "Legal",
//   },
//   {
//     question: "What contributor protections are in place?",
//     answer:
//       "All projects undergo rigorous vetting, and we require production companies to provide completion bonds for larger projects. Contributor funds are held in escrow until funding targets are met, and we conduct regular financial audits. However, as with any contribution, there is risk involved.",
//     category: "Account",
//   },
// ];

// const categories = [
//   "All",
//   "Contributing",
//   "Projects",
//   "Payments",
//   "Legal",
//   "Account",
// ];

// const FAQPage = () => {
//   const [activeCategory, setActiveCategory] = useState("All");
//   const [searchTerm, setSearchTerm] = useState("");
//   const [expandedIndex, setExpandedIndex] = useState(null);
// const [isSidebarOpen, setIsSidebarOpen] = useState(false);


//   const filteredFaqs = faqData.filter((faq) => {
//     const matchesCategory =
//       activeCategory === "All" || faq.category === activeCategory;
//     const matchesSearch = faq.question
//       .toLowerCase()
//       .includes(searchTerm.toLowerCase());
//     return matchesCategory && matchesSearch;
//   });

//   return (
//     <>
//       {/* <Sidebar /> */}

//         <Sidebar
//         isOpen={isSidebarOpen}
//         toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
//       />
//       <div className="faq-app-container">
//         <div className="sidebar-space"></div>

//         <main className="faq-main-content">
//           <div className="faq-page-header">
//             <h1 className="faq-page-title">
//               {/* <FaQuestionCircle />  */}
//               Frequently Asked Questions
//             </h1>

//             <div className="faq-search-container">
//               {/* <i className="fas fa-search"></i> */}
//               <input
//                 type="text"
//                 id="project-search"
//                 className="dc-form-control"
//                 placeholder="Search by project title..."
//                 autoComplete="off"
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//               />
//               <button className="search-icon-btn" type="button"></button>
//             </div>
//           </div>

//           <div className="categories">
//             {categories.map((cat) => (
//               <button
//                 key={cat}
//                 className={`category-btn ${
//                   activeCategory === cat ? "active" : ""
//                 }`}
//                 onClick={() => setActiveCategory(cat)}
//               >
//                 {cat}
//               </button>
//             ))}
//           </div>

//           <div className="faq-container">
//             {filteredFaqs.map((faq, index) => (
//               <div className="faq-item" key={index}>
//                 <div
//                   className="faq-question"
//                   onClick={() =>
//                     setExpandedIndex(expandedIndex === index ? null : index)
//                   }
//                 >
//                   <span>{faq.question}</span>
//                   {/* <FaChevronDown
//                   style={{
//                     transform:
//                       expandedIndex === index ? "rotate(180deg)" : "rotate(0deg)",
//                     transition: "transform 0.3s",
//                   }}
//                 /> */}
//                 </div>
//                 {expandedIndex === index && (
//                   <div className="faq-answer">
//                     <p>{faq.answer}</p>
//                   </div>
//                 )}
//               </div>
//             ))}
//           </div>

//           <div className="contact-section">
//             <h3 className="contact-title">Still have questions?</h3>
//             <p className="contact-text">
//               Our support team is available to help with any additional
//               questions you might have about contributing through Cinevestor.
//             </p>
//             <button className="contact-btn">
//               {/* <FaEnvelope /> */}
//               Contact Support
//             </button>
//           </div>
//         </main>
//       </div>
//     </>
//   );
// };

// export default FAQPage;









import React, { useState } from "react";
import "../CSS/faq.css";
import Sidebar from "./Sidebar";

const faqData = [
  {
    question: "How do I contribute in a film project?",
    answer:
      "To contribute in a film project on Cinevestor, simply browse our available projects, select one that interests you, and click the 'Contribute Now' button. You'll need to complete our contributor onboarding process, which includes verifying your identity and agreeing to the contribution terms. Minimum contributions vary by project.",
    category: "Contributing",
  },
  {
    question: "What is the typical return on contribution?",
    answer:
      "Potential Profits varies by project and depends on many factors including the project's budget, distribution deals, and overall success. Our historical average Potential Profits ranges from 15-30%, but this is not guaranteed. Each project page shows projected Potential Profits based on financial models.",
    category: "Projects",
  },
  {
    question: "How are profits distributed?",
    answer:
      "Profits are distributed quarterly after the project's release. Payments are made directly to your registered bank account once the project has recouped its production costs. You'll receive detailed financial reports showing revenue streams from theatrical, streaming, TV, and other distribution channels.",
    category: "Payments",
  },
  {
    question: "What happens if a project doesn't get funded?",
    answer:
      "If a project doesn't reach its funding goal by the deadline, all committed funds are returned to contributors in full. You won't be charged anything, and we'll notify you immediately if a project you're interested in doesn't get funded.",
    category: "Projects",
  },
  {
    question: "Can I sell my contribution to someone else?",
    answer:
      "Currently, contributions in film projects are illiquid and cannot be sold on a secondary market. However, we're developing a marketplace for future trading of film contributions. You'll maintain your contribution position until the project completes its revenue cycle.",
    category: "Legal",
  },
  {
    question: "What contributor protections are in place?",
    answer:
      "All projects undergo rigorous vetting, and we require production companies to provide completion bonds for larger projects. Contributor funds are held in escrow until funding targets are met, and we conduct regular financial audits. However, as with any contribution, there is risk involved.",
    category: "Account",
  },
];

const categories = ["All", "Contributing", "Projects", "Payments", "Legal", "Account"];

const FAQPage = () => {
  const [activeCategory, setActiveCategory] = useState("All");
  const [searchTerm, setSearchTerm] = useState("");
  const [expandedIndex, setExpandedIndex] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const filteredFaqs = faqData.filter((faq) => {
    const matchesCategory =
      activeCategory === "All" || faq.category === activeCategory;
    const matchesSearch = faq.question
      .toLowerCase()
      .includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  return (
    <>
      <Sidebar
        isOpen={isSidebarOpen}
        toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
      />

      <div className="faq-app-container">
        <div className="sidebar-space"></div>

        <main className="faq-main-content">
          <div className="faq-page-header">
            <h1 className="faq-page-title">Frequently Asked Questions</h1>

            <div className="faq-search-container">
              <input
                type="text"
                id="project-search"
                className="dc-form-control"
                placeholder="Search by project title..."
                autoComplete="off"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <button className="search-icon-btn" type="button"></button>
            </div>
          </div>

          <div className="categories">
            {categories.map((cat) => (
              <button
                key={cat}
                className={`category-btn ${activeCategory === cat ? "active" : ""}`}
                onClick={() => setActiveCategory(cat)}
              >
                {cat}
              </button>
            ))}
          </div>

          <div className="faq-container">
            {filteredFaqs.map((faq, index) => (
              <div
                className={`faq-item ${expandedIndex === index ? "active" : ""}`}
                key={index}
              >
                <div
                  className="faq-question"
                  onClick={() =>
                    setExpandedIndex(expandedIndex === index ? null : index)
                  }
                >
                  <span>{faq.question}</span>
                </div>

                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="contact-section">
            <h3 className="contact-title">Still have questions?</h3>
            <p className="contact-text">
              Our support team is available to help with any additional
              questions you might have about contributing through Cinevestor.
            </p>
            <button className="contact-btn">Contact Support</button>
          </div>
        </main>
      </div>
    </>
  );
};

export default FAQPage;
